import React, { useEffect, useState } from "react";
import { CommonAxiosGet } from "../../CommonUtils/CommonAxios";
import { config } from "../../CommonUtils/CommonURLS";
import { FormikProvider, useFormik, Form, Field, ErrorMessage } from "formik";
import * as bie from "react-bootstrap";
import Select from "react-select";
import { viewImage } from "../../CommonUtils/viewImage";
import { FaFilePdf } from "react-icons/fa";
export default function OverallNocStatusReport() {
  const [instDtls, setInstDtls] = useState([]);
  const [status, setStatus] = useState([]);

  const InstitutionFormik = useFormik({
    initialValues: {
      collcode: "",
    },
    onSubmit: (val) => {
      console.log(val);
    },
  });

  useEffect(() => {
    GetInstDtlsByCollcode();
  }, []);

  function GetInstDtlsByCollcode() {
    let url = config.url.FAC_URL + `getInstDetailsByCollcode`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        setInstDtls(res?.data?.data);
      } else {
        setInstDtls([]);
      }
    });
  }

  function GetStatus(collcode) {
    if (!collcode) {
      setStatus([]);
      return;
    }

    let url = config.url.FAC_URL + `getNocOverallStatusReport?Collcode=${collcode}`;

    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        setStatus(res?.data?.data);
      } else {
        setStatus([]);
      }
    });
  }

  const getScrutinyStatus = (item) => {
    if (item.noc_type === "management") return item.management_scrutiny;
    if (item.noc_type === "eop") return item.eop_scrutiny;
    if (item.noc_type === "shifting") return item.shifting_scrutiny;
    return "Not Done";
  };

  // {
  //     "recommended_physical": "Not Done", 2
  //     "final_status_by_jd_phase2": "Not Done",
  //     "coll_code": 20940,
  //     "inst_address": "SATTENAPALLI",
  //     "shifting_approvedby_section": "Done",  3
  //     "online_shifting_scrutiny": "Not Done",  1
  //     "noc_type": "eop",
  //     "eop_scrutiny": "Done",
  //     "management_scrutiny": "Not Done",
  //     "section_approved": "Done",
  //     "digi_sign_done_phase2": "Not Done",e6
  //     "principle_details": "MANUKONDA SRINIVASA REDDY,9247123623",
  //     "digi_sign_done": "Done",
  //     "college_def": "Not Done",  e1-
  //     "physical_shifting_scrutiny": "Not Done",  4
  //     "ub_name": "ACHARYA NAGARJUNA UNIVERSITY",
  //     "jd_approved": "Done",  eop
  //     "phase2_scrutiny": "Not Done",   e2
  //     "inst_name": "VIDYAKENDRAM DEGREE COLLEGE SATTENAPALLI",
  //     "college_done": "Done",
  //     "jd_approved_phase2": "Not Done",e3
  //     "final_status_by_jd": "Done", e5
  //     "section_approved_phase2": "Not Done" e4
  // }

  return (
    <div className="faculty-form-wrapper">
      <h5 className="mb-3 innerheader-new">
        <span>College Application Status</span>
      </h5>
      <div className="faculty-card">
        <FormikProvider value={InstitutionFormik}>
          <Form>
            <bie.Row>
              <bie.Col md={1}>
                <label>Select College:</label>
              </bie.Col>
              {/* <bie.Col md={4}>

                                <Field
                                    as="select"
                                    name="collcode"
                                    className="form-control"
                                    onChange={(e) => {
                                        InstitutionFormik.handleChange(e);
                                        GetStatus(e.target.value);
                                    }}
                                >
                                    <option value="">--Select--</option>
                                    {instDtls?.map((p, i) => (
                                        <option key={i} value={p.coll_code}>
                                            {p.inst_name}
                                        </option>
                                    ))}
                                </Field>

                                <ErrorMessage name="collcode" />
                            </bie.Col> */}

              <bie.Col md={4}>
                <Select
                  name="collcode"
                  options={instDtls?.map((p) => ({
                    value: p.coll_code,
                    label: p.inst_name,
                  }))}
                  placeholder="--Select--"
                  isSearchable
                  onChange={(selectedOption) => {
                    InstitutionFormik.setFieldValue("collcode", selectedOption?.value);

                    GetStatus(selectedOption?.value);
                  }}
                  value={
                    instDtls
                      ?.map((p) => ({
                        value: p.coll_code,
                        label: p.inst_name,
                      }))
                      .find((option) => option.value === InstitutionFormik.values.collcode) || null
                  }
                />

                <ErrorMessage name="collcode" component="div" className="text-danger" />
              </bie.Col>
            </bie.Row>
          </Form>
        </FormikProvider>
        <br />
        {/* {status?.length > 0 ? (<> */}

        {status?.length > 0 && (
          <div
            style={{
              background: "linear-gradient(135deg, #f8fafc, #e0f2fe)",
              borderRadius: "16px",
              padding: "22px",
              boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
              borderLeft: "6px solid #0d6efd",
              marginBottom: "20px",
              transition: "0.3s ease",
            }}
          >
            {/* HEADER */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "15px",
                flexWrap: "wrap",
                gap: "10px",
              }}
            >
              <h4
                style={{
                  margin: 0,
                  fontWeight: 700,
                  color: "#0f172a",
                }}
              >
                {status[0]?.inst_name}
              </h4>

              <span
                style={{
                  background: "#0d6efd",
                  color: "#fff",
                  padding: "6px 14px",
                  borderRadius: "20px",
                  fontSize: "12px",
                  fontWeight: 600,
                }}
              >
                {status[0]?.coll_code}
              </span>
            </div>

            {/* BODY */}
            <div>
              <div
                style={{
                  padding: "6px 0",
                  color: "#334155",
                  fontSize: "14px",
                }}
              >
                <b>University:</b> {status[0]?.ub_name}
              </div>

              <div
                style={{
                  padding: "6px 0",
                  color: "#334155",
                  fontSize: "14px",
                }}
              >
                <b>Address:</b> {status[0]?.inst_address}
              </div>

              <div
                style={{
                  padding: "6px 0",
                  color: "#334155",
                  fontSize: "14px",
                }}
              >
                <b>Principal:</b> {status[0]?.principle_details}
              </div>
            </div>
          </div>
        )}
        <div style={{ marginTop: "20px" }}>
          {status?.map((item, index) => {
            // const stepData = [
            //     {
            //         label: "College",
            //         status: item.college_done
            //     },

            //     {
            //         label: "Scrutiny",
            //         status: getScrutinyStatus(item)
            //     },
            //     {
            //         label: "JD Approved",
            //         status: item.jd_approved
            //     },
            //     {
            //         label: "Section Forwarded",
            //         status: item.section_approved
            //     },
            //     {
            //         label: "Final",
            //         status: item.final_status_by_jd
            //     },
            //     {
            //         label: "Digital Sign",
            //         status: item.digi_sign_done
            //     },
            //     {
            //         label: "College Deficiency Remarks",
            //         status: item.college_def
            //     },
            //     {
            //         label: "Phase 2 Scrutiny",
            //         status: item.phase2_scrutiny
            //     },
            //     {
            //         label: "Phase 2 Jd Status",
            //         status: item.jd_approved_phase2
            //     },
            //     {
            //         label: "Phase 2 section status",
            //         status: item.section_approved_phase2
            //     },
            //     {
            //         label: "Final Jd Status Phase 2",
            //         status: item.final_status_by_jd
            //     },
            //     {
            //         label: "Digi Sign  Phase 2",
            //         status: item.digi_sign_done_phase2
            //     },

            // ];
            const stepData = [
              { label: "College", status: item.college_done },
              ...(item.noc_type !== "shifting" ? [
                // { label: "Scrutiny", status: getScrutinyStatus(item) }
                {
                  label: item?.online_scru_remarks
                    ? `Scrutiny (${item.online_scru_remarks})`
                    : "Scrutiny",
                  status: getScrutinyStatus(item),
                },
              ] : []),
              ...(item.noc_type === "shifting"
                ? [
                  // { label: "Online Shifting Scrutiny", status: item.online_shifting_scrutiny },
                  { label: "Online Shifting Scrutiny", status: item.online_scru_remarks ? `${item.online_shifting_scrutiny} (${item.online_scru_remarks})` : item.online_shifting_scrutiny },

                  { label: "Recommended Physical", status: item.recommended_physical },

                  {
                    label: "Shifting Approved by Section",
                    status: item.final_pdf_sign ? (
                      <span>
                        {item.digi_sign_done} <FaFilePdf size={22} color="green" style={{ cursor: "pointer" }} onClick={() => viewImage(item.final_pdf_sign)} />
                      </span>
                    ) : (
                      item.digi_sign_done
                    ),
                    pdf: item.final_pdf_sign,
                    done: Boolean(item.final_pdf_sign) || item.digi_sign_done === "Done",
                  },

                  // { label: "Physical Shifting Scrutiny", status: item.physical_shifting_scrutiny },
                  {
                    label: "Physical Shifting Scrutiny",
                    status: `${item.physical_shifting_scrutiny} ${item?.phase2_scru_remarks ? `(${item.phase2_scru_remarks})` : ""}`,
                  },
                ]
                : []),
              ...(item.noc_type !== "shifting" ? [

                { label: "JD Status", status: item.jd_status ? `${item.jd_approved} (${item.jd_status})` : item.jd_approved },
              ]
                : []),
              // .............jd_approved_phase2
              ...(item.noc_type === "shifting"
                ? [
                  { label: "JD Status", status: item.phase2_status ? `${item.jd_approved} (${item.phase2_status})` : item.jd_approved },

                ]
                : []),

              // { label: "Section Forwarded", status: item.section_approved },

              { label: "Section Forwarded", status: item.section_phase2_remarks ? `${item.section_approved} (${item.section_phase2_remarks})` : item.section_approved },


              ...(item.noc_type === "shifting"
                ? [
                  {
                    label: "Digi Sign",
                    status: item.phase2_sign_pdf ? (
                      <span>
                        {item.digi_sign_done_phase2} <FaFilePdf size={22} color="#3D9C57" style={{ cursor: "pointer" }} title="View Signed PDF" onClick={() => viewImage(item.phase2_sign_pdf)} />
                      </span>
                    ) : (
                      item.digi_sign_done_phase2
                    ),
                    pdf: item.phase2_sign_pdf,
                    done: Boolean(item.phase2_sign_pdf) || item.digi_sign_done_phase2 === "Done",
                  },
                ]
                : []),

              ...(item.noc_type === "shifting"
                ? []
                : [
                  {
                    label: "Digi Sign",
                    status: item.final_pdf_sign ? (
                      <span>
                        {item.digi_sign_done} <FaFilePdf size={22} color="#3D9C57" style={{ cursor: "pointer" }} title="View Signed PDF" onClick={() => viewImage(item.final_pdf_sign)} />
                      </span>
                    ) : (
                      item.digi_sign_done
                    ),
                    pdf: item.final_pdf_sign,
                    done: Boolean(item.final_pdf_sign) || item.digi_sign_done === "Done",
                  },
                ]),

              ...(item.noc_type !== "shifting" && item.jd_status !== "Approved" && item.digi_sign_done === "Done"
                ? [
                  { label: "College Deficiency Remarks", status: item.college_def },
                  // { label: "Phase 2 Scrutiny", status: item.phase2_scrutiny },
                  { label: "Phase 2 Scrutiny", status: item.phase2_scru_remarks ? `${item.phase2_scrutiny} (${item.phase2_scru_remarks})` : item.phase2_scrutiny },

                  // { label: "Phase 2 Jd Status", status: item.jd_approved_phase2 },

                  { label: "Phase 2 Jd Status", status: item.final_remarks_phase2 ? `${item.jd_approved_phase2} (${item.final_remarks_phase2})` : item.jd_approved_phase2 },
                  // { label: "Phase 2 section status", status: item.section_approved_phase2 },
                  { label: "Phase 2 section Status", status: item.section_phase2_remarks ? `${item.section_approved_phase2} (${item.section_phase2_remarks})` : item.section_approved_phase2 },



                  {
                    label: "Digi Sign Phase 2",
                    status: (
                      <>
                        {console.log("PDF:", item.phase2_sign_pdf)}
                        {item.phase2_sign_pdf ? (
                          <span>
                            {item.digi_sign_done_phase2} <FaFilePdf size={22} color="green" style={{ cursor: "pointer" }} onClick={() => viewImage(item.phase2_sign_pdf)} />
                          </span>
                        ) : (
                          item.digi_sign_done_phase2
                        )}
                      </>
                    ),
                    pdf: item.phase2_sign_pdf,
                    done: Boolean(item.phase2_sign_pdf) || item.digi_sign_done_phase2 === "Done",
                  },
                ]
                : []),
              // ...(item.noc_type !== "shifting" ? [
              //     { label: "College Deficiency Remarks", status: item.college_def },
              //     { label: "Phase 2 Scrutiny", status: item.phase2_scrutiny },
              //     { label: "Phase 2 Jd Status", status: item.jd_approved_phase2 },
              //     { label: "Phase 2 section status", status: item.section_approved_phase2 },
              //     { label: "Final Jd Status Phase 2", status: item.final_status_by_jd_phase2 || item.final_status_by_jd },
              //     { label: "Digi Sign Phase 2", status: item.digi_sign_done_phase2 },
              // ] : [])
            ];
            return (
              <div
                key={index}
                style={{
                  background: "#fff",
                  padding: "20px",
                  borderRadius: "16px",
                  boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                  marginBottom: "18px",
                }}
              >
                {/* TITLE */}
                <h6
                  style={{
                    marginBottom: "20px",
                    fontWeight: 700,
                    color: "#0f172a",
                    fontSize: "16px",
                  }}
                >
                  {item.noc_type.toUpperCase()} NOC
                </h6>

                {/* STEPPER */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    position: "relative",
                    overflowX: "auto",
                    paddingBottom: "10px",
                  }}
                >
                  {stepData?.map((step, i) => {
                    // const getStatusText = (status) => {
                    //     if (typeof status === 'string') return status;
                    //     if (status?.props?.children) {
                    //         return typeof status.props.children === 'string' ? status.props.children : String(status.props.children);
                    //     }
                    //     return String(status);
                    // };

                    // const statusText = getStatusText(step.status);
                    // const isDone = typeof statusText === 'string' && (statusText === "Done" || statusText.startsWith("Done"));

                    const getStatusText = (status) => {
                      if (typeof status === "string") return status;
                      if (status?.props?.children) {
                        return typeof status.props.children === "string" ? status.props.children : String(status.props.children);
                      }
                      return String(status);
                    };

                    const statusText = getStatusText(step.status);

                    // ✅ Use explicit `done` flag when provided, otherwise fall back to text inference
                    const isDone = typeof step.done === "boolean" ? step.done : typeof statusText === "string" && (statusText === "Done" || statusText.startsWith("Done"));
                    return (
                      <div
                        key={i}
                        style={{
                          position: "relative",
                          flex: 1,
                          textAlign: "center",
                          minWidth: "120px",
                        }}
                      >
                        {/* LINE */}
                        {i !== stepData.length - 1 && (
                          <div
                            style={{
                              position: "absolute",
                              top: "18px",
                              left: "50%",
                              width: "100%",
                              height: "4px",
                              background: isDone ? "#22c55e" : "#e2e8f0",
                              zIndex: 1,
                              borderRadius: "10px",
                            }}
                          />
                        )}

                        {/* DOT */}
                        <div
                          style={{
                            width: "38px",
                            height: "38px",
                            borderRadius: "50%",
                            margin: "0 auto",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#fff",
                            fontWeight: 700,
                            fontSize: "14px",
                            position: "relative",
                            zIndex: 2,
                            background: isDone ? "linear-gradient(135deg,#22c55e,#16a34a)" : "linear-gradient(135deg,#ef4444,#dc2626)",
                          }}
                        >
                          {i + 1}
                        </div>

                        {/* LABEL */}
                        <div
                          style={{
                            fontSize: "12px",
                            marginTop: "8px",
                            fontWeight: 600,
                            color: "#334155",
                          }}
                        >
                          {step.label}
                        </div>

                        {/* STATUS */}
                        <div
                          style={{
                            fontSize: "11px",
                            marginTop: "4px",
                            fontWeight: 600,
                            color: isDone ? "#16a34a" : "#dc2626",
                          }}
                        >
                          {step.status}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>

        {/* </>) : (

                    <center className="text-danger mt-4 h5">***** No Data Found *****</center>

                )} */}
      </div>
    </div>
  );
}
